const ClientsPage = () => <div><h1 className="text-2xl font-bold text-emerald-900">Clients Management</h1><p>Finance clients page...</p></div>; export default ClientsPage
